import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export interface TableProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const TableTemplate: React.FC<React.PropsWithChildren<TableProps>> = ({ className, children }) => {
  return (
    <Wrapper className={className}>
      <table ref={forceSetWidthAuto}>{children}</table>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow-x: auto;
  border-top: 1px solid ${vars.v3Color.staticWhite};
  padding-bottom: 12px;
  table {
    min-width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    tr {
      &:first-of-type {
        border-top: 1px solid ${vars.v3Color.gray100};
      }
      border-bottom: 1px solid ${vars.v3Color.gray100};
    }
    th,
    td {
      padding: 13px 16px;
    }
    th {
      background-color: ${vars.v3Color.gray100};
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
      font-weight: 600;
      text-align: center;
    }
    td {
      color: ${vars.v3Color.gray700};
      font-size: 11px;
      line-height: 13px;
      font-weight: 400;
    }
    img {
      margin: 0 auto !important;
    }
  }
`;

function forceSetWidthAuto(node: HTMLTableElement | null) {
  if (node) {
    node.style.setProperty('width', 'auto', 'important');
  }
}
